<template>
  <div>
    <v-data-table @click:row="expandRow" :expanded.sync="expanded" :headers="headers" :items="list" item-key="id" :item-class="itemClass" class="elevation-1 table-expanded-style" :disable-pagination="true">
      <!-- <template v-slot:[`item.data-table-expand`]="{ item, isExpanded }">
        <div>aa--{{ item.leval }} --{{ isExpanded }}</div>
      </template> -->
      <template v-slot:[`item.id`]="{ item }">
        <div
          :style="{
            paddingLeft: (item.leval > 5 ? 5 : item.leval) * 15 + 'px'
          }"
        >
          <i
            :style="{
              visibility: item.children && item.children.length > 0 ? 'visible' : 'hidden'
            }"
            :class="['mdi', 'mdi-24px', 'icon-arrow', item.expanded ? 'mdi-chevron-down' : 'mdi-chevron-right']"
          ></i>
          <span class="id">{{ item.id }}</span>
        </div>
      </template>
      <!-- <template v-slot:[`item.id`]="{ item }">
        <span class="id">{{ item.id }}</span>
      </template> -->
      <template v-slot:[`item.value`]="{ item }">
        <span class="id">{{ item.value ? item.value.split(":")[0] : "" }}</span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="table-expanded-content">
          <tree-menu v-if="item.children" :list="item.children" :headers="headers" @clickItem="clickAction" />
        </td>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'check')">查看</v-btn>
        <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'add')">添加子项</v-btn>
        <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'edit')">编辑</v-btn>
        <v-btn class="ma-2 white--text" small color="error" @click="clickAction(item, 'delete')">删除</v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="checkDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">查看支付方式详情</span>
        </v-card-title>
        <v-card-text class="pay-modal-detail" v-if="currentObj">
          <div class="base-info">
            <p>名称：{{ currentObj.label }}</p>
            <p>id：{{ currentObj.id }}</p>
            <p>info：{{ currentObj.info }}</p>
            <p>value：{{ currentObj.value }}</p>
          </div>
          <div class="right" v-if="currentObj.childForm">
            <div class="item">
              <span class="label">表单配置项:</span>
              <div class="item-r">
                <ul class="form-ul">
                  <li v-for="(formItem, index) in currentObj.childForm" :key="index">
                    <span class="label">{{ formItem.title }}：</span>
                    <div class="v-input-box">
                      <v-text-field placeholder="请输入" v-model="formItem.value" solo required></v-text-field>
                      <p class="inputInfo">{{ formItem.info }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'TreeMenu',
  props: ['list', 'headers'],
  data () {
    return {
      text: [{ children: null, id: 1009, label: '5级', parentValue: '2222:2222', value: '11:1009', childForm: [{ type: 'input', field: 'ml85uzi2sn5p', title: '输入框', info: '', _fc_drag_tag: 'input', hidden: false, display: true }], parentId: 1008, info: '11' }],
      expanded: [],
      fApi: {},
      rule: [
        {
          type: 'input',
          field: 'input1',
          title: 'input1',
          value: ''
        },
        {
          type: 'input',
          field: 'input2',
          title: 'input2',
          value: ''
        }
      ],
      rule1: [
        {
          type: 'input',
          field: 'remark',
          title: '备注',
          info: '',
          props: {
            type: 'text',
            readonly: true
          },
          display: true,
          value: 'agree'
        }
      ],
      currentObj: null,
      checkDialog: false
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    itemClass (item) {
      const l = item.leval > 5 ? 5 : item.leval
      return item.children ? 'hasChild padding-left-' + l : 'noChild padding-left-' + l
    },
    expandRow (item, event) {
      if (item.children && item.children.length > 0) {
        if (event.isExpanded) {
          var index = this.expanded.findIndex(i => i === item)
          this.expanded.splice(index, 1)
          item.expanded = false
        } else {
          this.expanded.push(item)
          item.expanded = true
        }
      }
    },
    clickAction (item, type) {
      this.$emit('clickItem', item, type)
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 20px;
}
</style>
